export default __webpack_public_path__ + "static/media/jackpot-mobile.2a711662.webp";